import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { init as initSentry } from '@sentry/react';

import App from 'core/App';
import config from 'config';
import { StoreContext, stores } from 'core';
import * as serviceWorker from './serviceWorker';
import 'shared/components/common/localization';
import './styles/index.scss';

initSentry({ dsn: config.services.sentryDsn });

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <StoreContext.Provider value={stores}>
        <App />
      </StoreContext.Provider>
    </BrowserRouter>,
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
